<template>
  <Header/>
  <div class="ph-page">
    <div class="ph-toolbar">
      <label class="ph-field">
        <span>Проект</span>
        <select v-model="projectCurrent" @change="loadSets">
          <option v-for="p in projects" :key="p.id" :value="p.id">{{ p.name }}</option>
        </select>
      </label>

      <label class="ph-field" v-if="sets.length">
        <span>Группа списков</span>
        <select v-model="setCurrent">
          <option v-for="s in sets" :key="s.id" :value="s.id">{{ s.name }}</option>
        </select>
      </label>

      <button type="button" class="ph-btn" @click="createSet">+ Группа</button>
    </div>

    <p v-if="error" class="ph-err">{{ error }}</p>

    <div class="ph-lists" v-if="setCurrent">
      <PhraseListEditor
        ref="goodEditor"
        :key="setCurrent + ':good'"
        :project-id="projectCurrent" :set-id="setCurrent"
        kind="good" title="Желаемые фразы" @saved="loadSets"
      />
      <PhraseListEditor
        ref="badEditor"
        :key="setCurrent + ':bad'"
        :project-id="projectCurrent" :set-id="setCurrent"
        kind="bad" title="Нежелаемые фразы" @saved="loadSets"
      />
    </div>

    <PhraseScheduleBox
      v-if="currentSet"
      :key="setCurrent + ':schedule'"
      :project-id="projectCurrent"
      :set="currentSet"
      @updated="loadSets"
    />

    <PhraseReport
      v-if="setCurrent"
      :key="setCurrent"
      :project-id="projectCurrent"
      :set-id="setCurrent"
      :set-name="setCurrentName"
    />
  </div>
</template>

<script>
import axios from 'axios';
import Header from '@/components/Header.vue';
import PhraseListEditor from '@/components/phrases/PhraseListEditor.vue';
import PhraseReport from '@/components/phrases/PhraseReport.vue';
import PhraseScheduleBox from '@/components/phrases/PhraseScheduleBox.vue';

axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

export default {
  name: 'PhrasesPage',
  components: { Header, PhraseListEditor, PhraseReport, PhraseScheduleBox },
  data() {
    return {
      hostApi: process.env.VUE_APP_API_URL,
      projects: [],
      projectCurrent: '',
      sets: [],
      setCurrent: '',
      error: '',
    };
  },
  computed: {
    setCurrentName() {
      const found = this.sets.find(s => s.id === this.setCurrent);
      return found ? found.name : '';
    },
    currentSet() {
      return this.sets.find(s => s.id === this.setCurrent) || null;
    },
  },
  mounted() {
    this.loadProjects();
    window.addEventListener('beforeunload', this.onBeforeUnload);
  },
  unmounted() {
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  },
  beforeRouteLeave() {
    if (!this.hasUnsavedChanges()) return true;
    return window.confirm('Есть несохранённые изменения в списках фраз. Уйти со страницы?');
  },
  methods: {
    hasUnsavedChanges() {
      return Boolean(
        (this.$refs.goodEditor && this.$refs.goodEditor.isDirty)
        || (this.$refs.badEditor && this.$refs.badEditor.isDirty)
      );
    },
    onBeforeUnload(event) {
      if (!this.hasUnsavedChanges()) return;
      event.preventDefault();
    },
    async loadProjects() {
      try {
        const res = await axios.post(this.hostApi + '/api/v1/project/get', {
          clientId: localStorage.getItem('clientId'),
        });
        this.projects = res.data.data || [];
        if (this.projects.length) {
          this.projectCurrent = this.projects[0].id;
          await this.loadSets();
        }
      } catch (e) {
        this.error = 'Не удалось загрузить проекты';
      }
    },
    async loadSets() {
      if (!this.projectCurrent) return;
      this.error = '';
      try {
        const res = await axios.post(this.hostApi + '/api/v1/phraseset/get', {
          clientId: localStorage.getItem('clientId'),
          projectId: this.projectCurrent,
        });
        this.sets = res.data.data || [];
        // Бэк заводит «Основная» и «Эксперимент» при первом заходе,
        // поэтому пустым список быть не должен.
        if (this.sets.length && !this.sets.find(s => s.id === this.setCurrent)) {
          this.setCurrent = this.sets[0].id;
        }
      } catch (e) {
        this.error = 'Не удалось загрузить группы списков';
      }
    },
    async createSet() {
      const name = window.prompt('Название новой группы');
      if (!name) return;
      try {
        const res = await axios.post(this.hostApi + '/api/v1/phraseset/create', {
          clientId: localStorage.getItem('clientId'),
          projectId: this.projectCurrent,
          name: name,
        });
        await this.loadSets();
        this.setCurrent = res.data.data.id;
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.error) || 'Не удалось создать группу';
      }
    },
  },
};
</script>

<style scoped>
.ph-page { padding: 16px; max-width: 1200px; margin: 0 auto; }
.ph-toolbar { display: flex; flex-wrap: wrap; gap: 16px; align-items: flex-end; margin-bottom: 20px; }
.ph-field { display: flex; flex-direction: column; gap: 4px; font-size: 13px; }
.ph-field select { padding: 5px 8px; min-width: 220px; }
.ph-lists { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
@media (max-width: 900px) { .ph-lists { grid-template-columns: 1fr; } }
.ph-btn { padding: 5px 12px; border: 1px solid currentColor; background: transparent; cursor: pointer; border-radius: 4px; }
.ph-err { color: #b02a37; font-size: 13px; }
</style>
